export enum DownloadFamiliesReturnCodes
{
    Download = 0,
    NotDownload = 1,
    Error = 2
}